import { isSupportedUiLanguage, UiLanguageKey } from './languages';

const supportedCountriesObj: { [key in Country]: string } = {
  ALB: '',
  AUT: '',
  AZE: '',
  CYP: '',
  CZE: '',
  DEU: '',
  DNK: '',
  EST: '',
  FIN: '',
  GEO: '',
  GRC: '',
  HRV: '',
  HUN: '',
  ISL: '',
  ISR: '',
  JPN: '',
  KAZ: '',
  LTU: '',
  LUX: '',
  LVA: '',
  MLT: '',
  NOR: '',
  POL: '',
  SRB: '',
  SVK: '',
  SVN: '',
  SWE: '',
  UZB: '',
} as const;

const supportedCountries: readonly Country[] = Object.keys(supportedCountriesObj) as Country[];

/**
 * This function is deprecated because there are countries having different timezones.
 * Use {@link src/locale/useTimezone.ts} instead.
 * @deprecated
 */
export const countryToTimezone = (country: Country) => {
  const mapping: { [key in Country]: string } = {
    ALB: 'Europe/Tirane',
    AUT: 'Europe/Vienna',
    AZE: 'Asia/Baku',
    CYP: 'Asia/Nicosia',
    CZE: 'Europe/Prague',
    DEU: 'Europe/Berlin',
    DNK: 'Europe/Copenhagen',
    EST: 'Europe/Tallinn',
    FIN: 'Europe/Helsinki',
    GEO: 'Asia/Tbilisi',
    GRC: 'Europe/Athens',
    HRV: 'Europe/Zagreb',
    HUN: 'Europe/Budapest',
    ISL: 'Atlantic/Reykjavik',
    ISR: 'Asia/Jerusalem',
    JPN: 'Asia/Tokyo',
    KAZ: 'Asia/Almaty',
    LTU: 'Europe/Vilnius',
    LUX: 'Europe/Luxembourg',
    LVA: 'Europe/Riga',
    MLT: 'Europe/Malta',
    NOR: 'Europe/Oslo',
    POL: 'Europe/Warsaw',
    SRB: 'Europe/Belgrade',
    SVK: 'Europe/Bratislava',
    SVN: 'Europe/Ljubljana',
    SWE: 'Europe/Stockholm',
    UZB: 'Asia/Tashkent',
  };

  return mapping[country];
};

const isSupportedCountry = (country: string): country is Country => {
  return (supportedCountries as string[]).includes(country);
};

export const buildPrivacyTermsUrl = (locale: string, country?: string): string => {
  const localeFirstTwo = locale.substring(0, 2);
  let language: UiLanguageKey;
  if (isSupportedUiLanguage(locale)) {
    language = locale;
  } else if (isSupportedUiLanguage(localeFirstTwo)) {
    language = localeFirstTwo;
  } else {
    language = 'en';
  }

  const infixLocale = language.toLowerCase();

  // Specifying only the language will redirect to the privacy page based on geo ip
  // and countries where a given language is spoken
  if (!country || !isSupportedCountry(country)) {
    return `${process.env.WOLTCOM_URI}/${infixLocale}/privacy`;
  }

  const infixCountry = country.toLowerCase();

  // Specifying the country will redirect to the country-specific page for that language.
  // If a privacy page for that language doesn't exist for that country, it will fall back to English
  return `${process.env.EXPLORE_WOLTCOM_URI}/${infixLocale}/${infixCountry}/privacy`;
};
